// Registered analytics event names. Use the literal union so a typo at the
// call site is a compile error, and so new events go through code review
// (event-name sprawl is the #1 reason analytics dashboards become unusable).
//
// Naming convention: snake_case verb_object — `login_succeeded`, not `Login`.
// Past-tense verbs for completed actions, present for ongoing/state events.

export const ANALYTICS_EVENTS = {
  // Auth + onboarding
  LOGIN_SUBMITTED: 'login_submitted',
  LOGIN_SUCCEEDED: 'login_succeeded',
  LOGIN_FAILED: 'login_failed',
  LOGOUT: 'logout',
  SIGN_UP_STARTED: 'sign_up_started',
  SIGN_UP_COMPLETED: 'sign_up_completed',
  KYC_STARTED: 'kyc_started',
  KYC_SUBMITTED: 'kyc_submitted',

  // Discovery / detail
  PROPERTY_VIEWED: 'property_viewed',
  PROPERTY_BOOKMARKED: 'property_bookmarked',
  PROPERTY_UNBOOKMARKED: 'property_unbookmarked',

  // Money flows
  INVEST_STARTED: 'invest_started',
  ORDER_PLACED: 'order_placed',
  ORDER_FAILED: 'order_failed',
  WALLET_DEPOSIT_STARTED: 'wallet_deposit_started',
  WALLET_DEPOSIT_SUBMITTED: 'wallet_deposit_submitted',
  WALLET_WITHDRAWAL_SUBMITTED: 'wallet_withdrawal_submitted',

  // Infrastructure
  APP_ERROR: 'app_error',
  WEB_VITAL: 'web_vital',
} as const

export type AnalyticsEvent = (typeof ANALYTICS_EVENTS)[keyof typeof ANALYTICS_EVENTS]
